import React, { Component } from "react";
import { connect } from "react-redux";

import $ from "jquery";
import axios from "axios";

import * as sisMapActions from "store/modules/rds_sisMap";

import { Button, TextArea, Form } from "semantic-ui-react";
import { GiPositionMarker } from "react-icons/gi";
import { MdDeleteForever } from "react-icons/md";

import SisModal from "store/sis/sisModal";
import SisOverlay from "store/sis/SisOverlay";

import "./memo.scss";
import { bindActionCreators } from "redux";

class Memo extends Component {
	state = {
		page: 1,
		totalCount: 1,
		viewCount: 5,
		items: [],
		selectedFile: null,
	};

	openMemo = () => {
		const { sisMap } = this.props.sis;

		$(`#${this.props.id}, .memoNotice`).toggle();

		if (!this.state.overlay) {
			const overlay = new SisOverlay(".memoOverlay", sisMap.map, "bottom-left", [-40, -10]);

			this.setState({
				overlay,
			});
		}

		sisMap.map.on("singleclick", this.mapClickEvent);
	};

	addMemo = () => {
		const val = $(".txtMemo").val();
		const self = this;
		const formData = new FormData();

		const fileCnt = $(".fileWrap input").length;

		$.each($(".fileWrap input"), (idx, file) => {
			formData.append("file", file.files[0]);
		});

		formData.append("val", val);
		formData.append("x", this.state.x);
		formData.append("y", this.state.y);
		formData.append("photo", "N");
		formData.append("page", 1);

		axios
			.post("/map/insertMemo", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((res) => {
				// console.log(res);
				if (res.data === 1) {
					alert("메모등록을 완료하였습니다.");
					self.closeMemo();
				} else {
					alert("메모등록을 실패하였습니다.");
				}
			});
	};

	closeMemo = () => {
		const { sisMap } = this.props.sis;

		$(`#${this.props.id}, .memoNotice, .memoOverlay`).toggle();
		$(".txtMemo").val("");
		$(".fileWrap input").val("");

		sisMap.map.un("singleclick", this.mapClickEvent);
		this.selectMemo(this.state.page);
	};

	mapClickEvent = (e) => {
		$(".memoOverlay").show();
		this.state.overlay.setPosition(e.coordinate);

		this.setState({
			x: e.coordinate[0],
			y: e.coordinate[1],
		});
	};

	selectMemo = (page = 1) => {
		let items = [];

		// $.ajax({
		// 	url: "/map/selectMemo",
		// 	data: {
		// 		id: "admin",
		// 		page: page,
		// 	},
		// 	async: false,
		// 	success: (data) => {
		// 		items = data;
		// 	},
		// });

		// this.setState({
		// 	items,
		// 	page,
		// 	totalCount: items.length > 0 ? items[0].totalCount : 1,
		// 	pagination: <SisPagination totalCount={items.length > 0 ? items[0].totalCount : 1} viewCount={this.state.viewCount} onClick={this.selectMemo} />,
		// });

		return items;
	};

	deleteMemo = (evt) => {
		const id = $(evt.target).closest("td").attr("id");

		const isDelete = window.confirm("정말 삭제하시겟습니까?");

		if (isDelete) {
			$.ajax({
				url: "/map/deleteMemo",
				async: false,
				data: {
					id,
				},
				success: (isSuccess) => {
					if (isSuccess) {
						alert("메모를 삭제하였습니다.");
						this.selectMemo(this.state.page);
					} else {
						alert("메모삭제를 실패하였습니다.");
					}
				},
			});
		}
	};

	viewMemo = (evt) => {
		const { sisMap } = this.props.sis;

		const x = $(evt.target).closest("td").attr("centx");
		const y = $(evt.target).closest("td").attr("centy");
		const files = $(evt.target).closest("td").attr("files");
		const content = $(evt.target).closest("tr").find(".content").text();
		const coord = [parseFloat(x), parseFloat(y)];

		let viewOverlay = null;

		if (!this.state.viewOverlay) {
			viewOverlay = new SisOverlay(".viewOverlay", sisMap.map, "bottom-left", [-40, -10]);

			this.setState({
				viewOverlay,
			});

			sisMap.map.addOverlay(viewOverlay);
			sisMap.view.setCenter(coord);
		} else {
			viewOverlay = this.state.viewOverlay;
		}

		sisMap.view.setCenter(coord);
		viewOverlay.setPosition(coord);

		let arrFiles = [];

		if (files) {
			arrFiles = files.split(",");

			arrFiles.forEach((f) => {
				$(".imageWrap").append("<img src='/jngis/sisnet/mapMemo/" + f + "'/>");
			});
		}

		$(".viewOverlay textarea").val(content);
		$(".viewOverlay").show();
		$(`#${this.props.id}`).hide();
	};

	viewClose = () => {
		$(".viewOverlay textarea").val("");
		$(".fileWrap input").val("");
		$(".imageWrap").html("");
		$(".viewOverlay").hide();
		//$(`#${this.props.id}`).show();
	};

	setFile = (e) => {
		this.setState({
			selectedFile: e.target.files,
		});
	};

	componentDidMount() {
		this.selectMemo();
	}

	render() {
		return (
			<div>
				<div className="memoNotice">메모할 위치를 선택하여 주세요</div>
				<div className="viewOverlay">
					<div className="memoTitle">
						<span>메모내용</span>
					</div>
					<div className="memoContents">
						<Form>
							<label htmlFor="memoViewText">메모 내용</label>
							<TextArea
								id="memoViewText"
								name="memoViewText"
								className="txtMemo"
								placeholder="메모 내용 입력"
								disabled
								style={{
									resize: "none",
									borderRadius: "0 0 3px 3px",
								}}
							/>

							<div className="imageWrap"></div>

							<Button id="cancel" color="red" onClick={this.viewClose}>
								닫기
							</Button>
						</Form>
					</div>
				</div>

				<div className="memoOverlay">
					<div className="memoTitle">
						<span>메모등록</span>
					</div>
					<div className="memoContents">
						<Form>
							<label htmlFor="memoAddText">메모 내용</label>
							<TextArea
								id="memoAddText"
								name="memoAddText"
								className="txtMemo"
								aria-labelledby="memoAddLabel"
								placeholder="메모 내용 입력"
								style={{
									resize: "none",
									borderRadius: "0 0 3px 3px",
								}}
							/>

							<div className="fileWrap">
								<input name="memoFile" type="file" onChange={this.setFile} />
							</div>

							<Button id="add" color="teal" onClick={this.addMemo}>
								등록
							</Button>
							<Button id="cancel" color="red" onClick={this.closeMemo}>
								취소
							</Button>
						</Form>
					</div>
				</div>

				<SisModal
					id={this.props.id}
					title="사진메모"
					draggable
					closeEvent={this.stopCreator}
					contents={
						<div className="memoWrap">
							<table>
								<caption>사진메모</caption>
								<colgroup>
									<col style={{ width: "70px" }} />
									<col style={{ width: "250px" }} />
									<col style={{ width: "90px" }} />
									<col style={{ width: "90px" }} />
								</colgroup>
								<thead>
									<tr>
										<th>선택</th>
										<th className="left">내용</th>
										<th>보기</th>
										<th>삭제</th>
									</tr>
								</thead>
								<tbody>
									{this.state.items.map((item, idx) => {
										return (
											<tr key={idx}>
												<td>v</td>
												<td className="content left">{item.memoContent}</td>
												<td centx={item.centX} centy={item.centY} files={item.files} onClick={this.viewMemo}>
													<GiPositionMarker size="25px" />
												</td>
												<td id={item.seqNo} onClick={this.deleteMemo}>
													<MdDeleteForever size="25px" />
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>

							<div className="paginationWrap">{this.state.pagination}</div>

							<Button id="addMemo" onClick={this.openMemo}>
								추가
							</Button>
						</div>
					}
				/>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
	})
)(Memo);
